import React from "react";
import {TranslationDomainEnum} from "../../../types/enums";
import {Checkbox, Form, Radio, Select, SelectProps} from "antd";
import {Translate} from "../../../components/util/translation.util";

const { Option } = Select;

type Props = {
    name: string,
    label: string,
    expanded: boolean,
    multiple: boolean,
    vertical: boolean,
    disabled: boolean,
    choices: Array<{ name: string, value: any }>,
    translationDomain: TranslationDomainEnum,
    choiceTranslationDomain?: TranslationDomainEnum,
    rules: any,
    onChange?: () => void,
    errors: { [key: string]: string[] },
    validateTrigger?: string,
}

export const ChoiceType: React.FC<Props> = ({name, label, translationDomain, choiceTranslationDomain, rules, choices, expanded, multiple, vertical, onChange, errors, validateTrigger= 'onBlur'}) => {
    let selectProps: SelectProps = {};
    let itemPositioningStyle: any = {};

    if (multiple) {
        selectProps.mode = "multiple";
    }

    if (vertical) {
        itemPositioningStyle.width = "100%";
    }

    return (
            <Form.Item
                    labelAlign={`left`}
                    name={name.split('.')}
                    label={<Translate message={label} domain={translationDomain}/>}
                    rules={rules}
                    validateTrigger={validateTrigger}
            >
                {!expanded && (
                        <Select
                                {...selectProps}
                                allowClear
                                style={{width: '100%'}}
                                placeholder="Please select"
                                onChange={onChange}
                        >
                            {
                                    choices && choices.map((choice: any, key: number) => {
                                        return (
                                                <Option key={key} value={choice.value}>
                                                    <Translate message={choice.name} domain={choiceTranslationDomain ?? translationDomain}/>
                                                </Option>
                                        )
                                    })
                            }
                        </Select>
                )}

                {(!multiple && expanded) && (
                        <Radio.Group onChange={onChange}>
                            {
                                    choices && choices.map((choice: any, key: number) => {
                                        return (
                                                <Radio style={itemPositioningStyle} key={key} value={choice.value}>
                                                    <Translate message={choice.name} domain={choiceTranslationDomain ?? translationDomain}/>
                                                </Radio>
                                        )
                                    })
                            }
                        </Radio.Group>
                )}

                {(multiple && expanded) && (
                        <Checkbox.Group onChange={onChange}>
                            {
                                    choices && choices.map((choice: any, key: number) => {
                                        return (
                                                <Checkbox style={itemPositioningStyle} key={key} value={choice.value}>
                                                    <Translate message={choice.name} domain={choiceTranslationDomain ?? translationDomain}/>
                                                </Checkbox>
                                        )
                                    })
                            }
                        </Checkbox.Group>
                )}
            </Form.Item>
    )
}